import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "bookmark",
  "use": "bookmark-usage",
  "viewBox": "0 0 12 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 14\" id=\"bookmark\"><path d=\"M9.77 1.5c.4 0 .73.33.73.73V12.5L6.9 9.8 6 9.13l-.9.67-3.6 2.7V2.23c0-.4.33-.73.73-.73h7.54zm0-1.5H2.23C1 0 0 1 0 2.23V12.5a1.498 1.498 0 002.4 1.2L6 11l3.6 2.7a1.498 1.498 0 002.4-1.2V2.23C12 1 11 0 9.77 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol